import { Category } from "../models/Category";

export const GET_CATEGORIES = "GET_CATEGORIES";

export interface GetCategories {
  type: typeof GET_CATEGORIES;
  payload: Array<Category> | undefined;
}

export type CategoryActions =
  | GetCategories;

